var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_2",
    "data-name": "Laag 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.44 9.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:inherit;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_1",
    "data-name": "Laag 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    className: "cls-1",
    d: "M.14,5.3l4.3,4.3a.6.6,0,0,0,.8,0l.3-.3a.48.48,0,0,0,0-.7h0l-3-3h10.6a.45.45,0,0,0,.3-.4h0V4.6a.32.32,0,0,0-.3-.3H2.64l3-3a.6.6,0,0,0,0-.8L5.34.2a.6.6,0,0,0-.8,0L.24,4.5C-.06,4.8-.06,5.1.14,5.3Z",
    transform: "translate(0 -0.05)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.8b2c485f88bb6d42063952ecd568070d.svg";
export { ForwardRef as ReactComponent };